<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="div_loading">
        <div class="my-container" [hidden]="!loading">
            <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
        </div>
    </div>
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        {{ title }}
        <span class="close" (click)="close()">
            <mat-icon>close</mat-icon>
        </span>
    </div>
</div>


<div mat-dialog-content class="matDialogContent">
    <div class="row">
        <form [formGroup]="form1">
            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="cate2" class='wh-label'>
                    <span *ngIf="lang == 1"> دسته میانی : </span>
                    <span (click)="reset_input(220)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class='wh-input' formControlName="cate2_title" autocomplete="off"
                        (click)="load_services(220)" required>
                    <input class='wh-input' formControlName="cate2" autocomplete="off" [hidden]="true">
                </label>
            </div>
            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="material" class='wh-label'>
                    <span *ngIf="lang == 1">دسته کالا : </span>
                    <span (click)="reset_input(171)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class='wh-input' formControlName="material_title" autocomplete="off"
                        (click)="load_services(171)" required>
                    <input class='wh-input' formControlName="material" autocomplete="off" [hidden]="true">
                </label>
            </div>
            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="meter" class='wh-label'>
                    <span *ngIf="lang == 1"> متره : </span>
                    <input class='wh-input' formControlName="meter" autocomplete="off" required>
                </label>
            </div>
            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="meter" class='wh-label'>
                    <span *ngIf="lang == 1"> واحد : </span>
                    <input class='wh-input' formControlName="weight" autocomplete="off" required readonly>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                style="padding-top: 1.5rem;">
                <button (click)="check_for_repeat()" [disabled]="!form1.valid">
                    اضافه کردن
                </button>
            </div>
        </form>
    </div>

    <input class="pe1" [ngClass]="{en1:lang == 2}" style="width:100%" (keyup)="get_material(2)" name="search"
        [(ngModel)]="search" autocomplete="off">
    <div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
        style='overflow-x:auto;direction:rtl;max-height: 10rem;'>
        <mat-table [dataSource]="dataSource" style='min-width:100%'
            class='table-scroll mat_table_fa_without_scroll_bg mat_table_fa_without_scroll_bg not- pe1'
            [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}" [ngStyle]="lang == 2 && {direction:'ltr'}">
            <ng-container matColumnDef="row">
                <mat-header-cell *matHeaderCellDef style="max-width:70px">
                    #
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style="max-width:70px">{{ i+1 }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="title">
                <mat-header-cell *matHeaderCellDef style="max-width:180px">
                    <span *ngIf="lang == 1">عنوان کالا</span>
                    <span *ngIf="lang == 2">---</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor right"
                    (click)="open_detaile(i,x.wharehouse_order_id,x.wharehouse_material_title)" style="max-width:180px">
                    <div class="right">{{x.wharehouse_material_title | substr:0:40 }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cate2">
                <mat-header-cell *matHeaderCellDef style="min-width:180px">
                    <span *ngIf="lang == 1">دسته میانی</span>
                    <span *ngIf="lang == 2">---</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor right"
                    (click)="open_detaile(i,x.wharehouse_order_id,x.wharehouse_material_title)" style="min-width:180px">
                    <div class="right"> {{ x.wharehouse_material_cate2_title }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="number">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">مقدار</span>
                    <span *ngIf="lang == 2">---</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor"
                    (click)="open_detaile(i,x.wharehouse_order_id,x.wharehouse_material_title)">
                    <div> {{ x.wharehouse_order_number }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="weight">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">واحد</span>
                    <span *ngIf="lang == 2">---</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor"
                    (click)="open_detaile(i,x.wharehouse_order_id,x.wharehouse_material_title)">
                    <div> {{ x.wharehouse_weight_title }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="price">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">قیمت واحد به تومان</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor"
                    (click)="open_detaile(i,x.wharehouse_order_id,x.wharehouse_material_title)">
                    {{
                    x.wharehouse_order_cost | number }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="zarayeb">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">جمع ظرایب</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor"
                    (click)="open_detaile(i,x.wharehouse_order_id,x.wharehouse_material_title)">
                    {{
                    x.zarayeb }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="discount">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1"> تخفیف به تومان</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor"
                    (click)="open_detaile(i,x.wharehouse_order_id,x.wharehouse_material_title)">
                    {{
                    x.wharehouse_order_discount | number }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="sum">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">قیمت نهایی به تومان</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor"
                    (click)="open_detaile(i,x.wharehouse_order_id,x.wharehouse_material_title)">
                    {{
                    x.sum | number }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="operation">
                <mat-header-cell *matHeaderCellDef style='max-width:100px'>
                    <span *ngIf="lang == 1"> عملیات </span>
                    <span *ngIf="lang == 2">Operation</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style='max-width:100px'>
                    <span (click)="open_detaile(i,x.wharehouse_order_id,x.wharehouse_material_title)"><i
                            class="fas fa-desktop icon"></i></span>
                    <span class="operation-icon" (click)="check_access(3,0,x.wharehouse_order_id,0,1)"><i
                            class="far fa-trash-alt icon" style='margin:0px 4px;'></i></span>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
            <mat-row *matRowDef="let x;let i = index;columns:displayedColumns"
                (click)="get_bg(x.wharehouse_material_id)"
                (keyup.enter)="select(x.wharehouse_material_id,x.wharehouse_material_title)"
                [ngClass]="{mat_table_selected:row_id == x.wharehouse_material_id}"></mat-row>
        </mat-table>
    </div>
    <div class="sum_all">
        قیمت کل به عدد {{ sum_all | number }} تومان
        به حروف
        {{ sum_all_letter }}
    </div>
</div>